import React from 'react'

export default function (props) {
    const isCreate = ('create' in props) ? props.create : 'WRAP_CREATE_UNDEFINED'
    const isShow = ('show' in props) ? props.show : 'WRAP_SHOW_UNDEFINED'
    let tag
    if (props.tag === null) {
        tag = null
    } else {
        tag = props.tag || 'div'
    }
    // 定义了create
    if (isCreate !== 'WRAP_CREATE_UNDEFINED') {
        if (!props.create) {
            return null
        } else {
            if (tag === null) {
                return props.children
            } else {
                return (
                    React.createElement(tag, {
                        className: props.className || ''
                    }, props.children)
                )
            }
        }
    } else {
        return (
            React.createElement(tag, {
                className: props.className || '',
                style: { display: getShowStyle(props.show) },
            }, props.children)
        )
    }
}

function getShowStyle(show) {
    if (show === undefined) {
        return 'inherit'
    }
    return show ? 'inherit' : 'none'
}

/*
类似 vue v-if v-show 控制子元素的创建或者显示
1.
<Wrap create={false}>
  <p>foo</p>
</Wrap>
会转为
<div>
</div>

2.
<Wrap show={false} className='flex' tag='footer'>
  <p>foo</p>
</Wrap>
会转为
<footer style="display: none" class='flex'>
    <p>foo</p>
</footer>

3. 没有tag的话只支持create属性
<Wrap tag={null}>
  <p>foo</p>
</Wrap>
会转为
<p>foo</p>
*/


// WEBPACK FOOTER //
// ./src/components/wk/WKVisible.js